
import { Component, Input, OnInit } from '@angular/core';
import { BudgetAccountLineDTO, BudgetDTO, LotBudgetAccountLineDTO, LotBudgetDTO, ProcurementProjectDTO, ProcurementProjectLotDTO } from '../../api/plyca-dtos-v2';
import { BaseComponent } from '../../components/common/baseComponent/base.component';

/**
 * Clase auxiliar para tabla de 'Distribución anualidades/financiación'.
 */
class DistributionLine {

  lot: ProcurementProjectLotDTO;
  accountLine: LotBudgetAccountLineDTO;
  summatoryLine = false;
  totalLine = false;

  constructor(lot: ProcurementProjectLotDTO, accountLine: LotBudgetAccountLineDTO) {
    this.lot = lot;
    this.accountLine = accountLine;
  }
}

@Component({
  selector: 'plyca-projectBudgetSummary',
  templateUrl: 'procurementProjectBudgetSummary.template.html'
})
export class ProcurementProjectBudgetSummaryComponent extends BaseComponent implements OnInit {

  @Input()
  project: ProcurementProjectDTO;

  // propiedades tabla financiacion
  public financeLines: {
    data?: Array<BudgetAccountLineDTO>;
    total?: number
  };
  public financeColHeaders: Array<string>;

  // propiedades tabla presupuesto por lotes
  public budgetLines: {
    data?: Array<ProcurementProjectLotDTO>;
    totalestimatedAmountSum?: number;
    amountExcludingTaxesSum?: number;
    totalTaxSum?: number;
    totalAmountSum?: number;
  };
  public budgetColHeaders: Array<string>;

  // propiedades tabla distribución anualidades/financiación
  public distributionLines: Array<DistributionLine>;
  // totales por agrupacion en un Map con clave 'lotNumber'
  // public distributionLinesTotal: Map<number, number>;
  public distributionColHeaders: Array<string>;



  constructor() {
    super();
    this.financeColHeaders = [
      'Año',
      'Orgánica',
      'Programa',
      'Económica',
      'Presupuesto total con IVA'
    ];
    this.budgetColHeaders = [
      'Lote',
      'Valor estimado',
      'Presup. sin IVA',
      'Tipo IVA',
      'Tipos',
      'Total IVA',
      'Presup. base licitacion',
    ];
    this.distributionColHeaders = [
      'Lote',
      'Año',
      'Orgánica',
      'Programa',
      'Económica',
      'Importe'
    ]
    // inicializar objetos de tablas
    this.financeLines = {
      data: []
    };
    this.budgetLines = {
      data: []
    };
    this.distributionLines = [];
  }

  ngOnInit(): void {
    if (this.project) {
      this.initFinanceTable();
      this.initBudgetTable();
      this.initDistributionTable();
    }
  }

  private initFinanceTable(): void {
    if (this.project.budget?.budgetAccounLine) {
      let totalAmount = 0;
      this.project.budget.budgetAccounLine.forEach((line: BudgetAccountLineDTO) => {
        totalAmount += line.budget?.totalAmount || 0;
      });
      if (this.project.budget.budgetAccounLine.length > 0) {
        let sumBudget = new BudgetAccountLineDTO();
        let budget = new BudgetDTO();
        budget.totalAmount = totalAmount;
        sumBudget.budget = budget;
        // el sort se hace con el operador [...array].sort para no afectar al orden de la lista original
        let orderedBudget = [...this.project.budget.budgetAccounLine]
          .sort((budget1, budget2) => (budget1.year || Number.MAX_VALUE) - (budget2.year || Number.MAX_VALUE));
        this.financeLines.data = [].concat(orderedBudget);
        this.financeLines.data.push(sumBudget);
      }
    }
  }

  private initBudgetTable(): void {
    if (this.project.breakdownLot?.lots) {
      let totalestimatedAmountSum = 0;
      let amountExcludingTaxesSum = 0;
      let totalTaxSum = 0;
      let totalAmountSum = 0;
      // el sort se hace con el operador [...array].sort para no afectar al orden de la lista original
      let orderedLots = [...this.project.breakdownLot.lots].sort((lot1, lot2) => (lot1.lotNumber || 0) - (lot2.lotNumber || 0));
      orderedLots.forEach((lot: ProcurementProjectLotDTO) => {
        totalestimatedAmountSum += lot.budget?.estimatedAmount || 0;
        amountExcludingTaxesSum += lot.budget?.amountExcludingTaxes || 0;
        totalTaxSum += lot.budget?.totalTaxes || 0;
        totalAmountSum += lot.budget?.totalAmount || 0;
      });
      if (orderedLots.length > 0) {
        let sumLot = new ProcurementProjectLotDTO();
        let lotBudget = new LotBudgetDTO();
        lotBudget.estimatedAmount = totalestimatedAmountSum;
        lotBudget.amountExcludingTaxes = amountExcludingTaxesSum;
        lotBudget.totalTaxes = totalTaxSum;
        lotBudget.totalAmount = totalAmountSum;
        sumLot.budget = lotBudget
        this.budgetLines.data = [].concat(orderedLots);
        this.budgetLines.data.push(sumLot);
      }
    }
  }

  private initDistributionTable(): void {
    if (this.project.breakdownLot?.lots) {
      // el sort se hace con el operador [...array].sort para no afectar al orden de la lista original
      let orderedLots = [...this.project.breakdownLot.lots].sort((lot1, lot2) => (lot1.lotNumber || 0) - (lot2.lotNumber || 0));
      let previousLot: ProcurementProjectLotDTO;
      let totalLine = 0;
      let totalLots = 0;
      this.distributionLines = [];
      orderedLots.forEach((lot: ProcurementProjectLotDTO) => {
        if (lot.budget?.lotBudgetAccountLine) {
          lot.budget?.lotBudgetAccountLine?.forEach((budgetAccountLine: LotBudgetAccountLineDTO) => {
            if (previousLot && previousLot.lotNumber !== lot.lotNumber) {
              this.addSumDistributionLine(totalLine, previousLot);
              // inicializar sumatorio de linea
              totalLine = 0;
            }
            // anyadir linea
            this.distributionLines.push(new DistributionLine(lot, budgetAccountLine));
            // contabilizar totales
            let total = budgetAccountLine.budget?.totalAmount || 0;
            totalLine += total;
            totalLots += total;
            previousLot = lot;
          });
        }
      }
      );
      if (this.distributionLines?.length > 0) {
        // total del último lote
        this.addSumDistributionLine(totalLine, previousLot);
        // total lotes
        this.addTotalDistributionLine(totalLots, undefined);
      }
    }
  }

  private addTotalDistributionLine(totalAmount: number, lot: ProcurementProjectLotDTO) {
    let sumLotLine = this.addDistributionLineAmount(totalAmount, lot);
    sumLotLine.totalLine = true;
  }

  private addSumDistributionLine(totalAmount: number, lot: ProcurementProjectLotDTO) {
    let sumLotLine = this.addDistributionLineAmount(totalAmount, lot);
    sumLotLine.summatoryLine = true;
  }

  private addDistributionLineAmount(totalAmount: number, lot: ProcurementProjectLotDTO) {
    let sumBudgetAccountLine = new LotBudgetAccountLineDTO();
    sumBudgetAccountLine.budget = new BudgetDTO();
    sumBudgetAccountLine.budget.totalAmount = totalAmount;
    // anyadir sumatorio de lote anterior
    let sumLotLine = new DistributionLine(lot, sumBudgetAccountLine);
    this.distributionLines.push(sumLotLine);
    return sumLotLine;
  }
}
